import React from 'react';
import clsx from 'clsx';

import styles from './Tail.module.scss';

export default function Tail({ className, color, direction }) {
	const tailStyle = {
		backgroundColor: color
	};
	return (
		<div className={clsx(styles.root, direction && styles[direction])}>
			<div
				className={clsx(styles.tail, className)}
				style={tailStyle}
			></div>
		</div>
	);
}
